var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.8121 0.319824H7.2C2.604 0.319824 0 2.92383 0 7.51982V20.1199C0 24.7158 2.604 27.3198 7.2 27.3198H19.8121C24.408 27.3198 27 24.7158 27 20.1199V7.51982C27 2.92383 24.408 0.319824 19.8121 0.319824Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.0889 13.3912V17.6029C20.0889 19.5436 18.5139 21.1186 16.5733 21.1186H10.428C8.48735 21.1186 6.91235 19.5436 6.91235 17.6029V13.4404C7.44673 14.017 8.2061 14.3475 9.02876 14.3475C9.9147 14.3475 10.7655 13.9045 11.2999 13.1943C11.778 13.9045 12.5936 14.3475 13.5007 14.3475C14.4007 14.3475 15.2022 13.9256 15.6874 13.2225C16.2288 13.9186 17.0655 14.3475 17.9374 14.3475C18.7882 14.3475 19.5616 14.0029 20.0889 13.3912Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6018 6.26123H11.3831L10.8627 11.4362C10.8206 11.9144 10.8909 12.3644 11.0666 12.7722C11.4745 13.7284 12.4307 14.3472 13.4995 14.3472C14.5823 14.3472 15.5175 13.7425 15.9393 12.7792C16.0659 12.4769 16.1432 12.1253 16.1503 11.7667V11.6331L15.6018 6.26123Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M20.7842 11.1972L20.5803 9.24951C20.285 7.12607 19.3217 6.26123 17.2615 6.26123H14.5615L15.0818 11.5347C15.0889 11.605 15.0959 11.6823 15.0959 11.8159C15.1381 12.1815 15.2506 12.519 15.4193 12.8214C15.9256 13.7495 16.91 14.3472 17.9365 14.3472C18.8717 14.3472 19.7154 13.9323 20.2428 13.2011C20.6646 12.6386 20.8545 11.9284 20.7842 11.1972Z",
    fill: "#CE2600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M9.69597 6.26123C7.62878 6.26123 6.67253 7.12607 6.37019 9.27061L6.18034 11.2042C6.11003 11.9565 6.31394 12.6878 6.75691 13.2573C7.29128 13.9534 8.11394 14.3472 9.028 14.3472C10.0546 14.3472 11.0389 13.7495 11.5382 12.8354C11.721 12.519 11.8405 12.1534 11.8757 11.7737L12.4241 6.26826H9.69597V6.26123Z",
    fill: "#CE2600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0423 17.0966C12.1493 17.188 11.4744 17.9473 11.4744 18.8473V21.1184H15.5173V19.0934C15.5243 17.6239 14.6595 16.9278 13.0423 17.0966Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlet);
export default __webpack_public_path__ + "static/media/outlet.ab1bd0e55bc0dbd2718089bb400085f3.svg";
export { ForwardRef as ReactComponent };